// Cost-of-living index by U.S. metro area. 100 = national average;
// higher = more expensive, lower = cheaper (same convention Numbeo and
// similar tools use).
//
// Source: derived from the U.S. Bureau of Economic Analysis's Regional
// Price Parities (RPP) release for calendar year 2023 -- a real,
// government-published, public-domain cost-of-living index covering
// U.S. metro areas, the same underlying data cited by the Census Bureau
// and used in mainstream cost-of-living journalism. This is NOT
// crowdsourced or scraped -- it's built from BEA's own published figures
// (via the Tax Foundation's public republication of the BEA release).
//
// State-level fields (income tax, sales tax, property tax, home value)
// source: Tax Foundation 2026 state tax data releases (individual income
// tax top marginal rates; combined state+local sales tax rates) and
// Census Bureau ACS 2024 5-year estimates via Tax Foundation (effective
// property tax rates; median home values). All real, current, government-
// or Census-sourced figures -- not estimates or placeholders.
//
// Honest limitations, worth keeping in mind:
// - 2023 cost-of-living index, 2026 tax rates, 2024 property/home value data
//   -- each dataset's own most recent available year, not artificially
//   aligned to one date
// - Metro-area resolution for cost-of-living, STATE-level for taxes and
//   property figures (property tax and home value both vary significantly
//   by county within a state -- these are state averages, a starting point
//   not a substitute for checking the specific county)
// - Covers ~127 major U.S. metros for the cost-of-living index specifically
export interface MetroColData {
  city: string;
  metro: string;
  index: number;
  state: string;
  incomeTaxTopRate: number;
  salesTaxCombined: number;
  propertyTaxRate: number;
  medianHomeValue: number;
}

export const METRO_COL_DATA: MetroColData[] = [
  { city: "Shreveport, LA", metro: "Shreveport-Bossier City, LA", index: 87.1, state: "LA", incomeTaxTopRate: 3.0, salesTaxCombined: 10.11, propertyTaxRate: 0.55, medianHomeValue: 167369 },
  { city: "Little Rock, AR", metro: "Little Rock-North Little Rock-Conway, AR", index: 89.1, state: "AR", incomeTaxTopRate: 3.9, salesTaxCombined: 9.46, propertyTaxRate: 0.56, medianHomeValue: 141465 },
  { city: "Springfield, MO", metro: "Springfield, MO", index: 89.3, state: "MO", incomeTaxTopRate: 4.7, salesTaxCombined: 8.44, propertyTaxRate: 0.89, medianHomeValue: 175712 },
  { city: "Mobile, AL", metro: "Mobile, AL", index: 89.4, state: "AL", incomeTaxTopRate: 5.0, salesTaxCombined: 9.46, propertyTaxRate: 0.37, medianHomeValue: 159660 },
  { city: "Wichita, KS", metro: "Wichita, KS", index: 89.5, state: "KS", incomeTaxTopRate: 5.58, salesTaxCombined: 8.69, propertyTaxRate: 1.21, medianHomeValue: 138825 },
  { city: "Tulsa, OK", metro: "Tulsa, OK", index: 89.5, state: "OK", incomeTaxTopRate: 4.5, salesTaxCombined: 9.06, propertyTaxRate: 0.79, medianHomeValue: 152013 },
  { city: "Flint, MI", metro: "Flint, MI", index: 89.8, state: "MI", incomeTaxTopRate: 4.25, salesTaxCombined: 6.0, propertyTaxRate: 1.19, medianHomeValue: 197293 },
  { city: "Fort Wayne, IN", metro: "Fort Wayne, IN", index: 90.0, state: "IN", incomeTaxTopRate: 2.95, salesTaxCombined: 7.0, propertyTaxRate: 0.76, medianHomeValue: 191899 },
  { city: "Rockford, IL", metro: "Rockford, IL", index: 90.1, state: "IL", incomeTaxTopRate: 4.95, salesTaxCombined: 8.96, propertyTaxRate: 1.88, medianHomeValue: 153020 },
  { city: "El Paso, TX", metro: "El Paso, TX", index: 90.2, state: "TX", incomeTaxTopRate: 0.0, salesTaxCombined: 8.2, propertyTaxRate: 1.4, medianHomeValue: 185771 },
  { city: "Sioux Falls, SD", metro: "Sioux Falls, SD", index: 90.3, state: "SD", incomeTaxTopRate: 0.0, salesTaxCombined: 6.11, propertyTaxRate: 1.0, medianHomeValue: 182992 },
  { city: "Toledo, OH", metro: "Toledo, OH", index: 90.4, state: "OH", incomeTaxTopRate: 2.75, salesTaxCombined: 7.29, propertyTaxRate: 1.36, medianHomeValue: 196325 },
  { city: "Jackson, MS", metro: "Jackson, MS", index: 90.7, state: "MS", incomeTaxTopRate: 4.0, salesTaxCombined: 7.06, propertyTaxRate: 0.58, medianHomeValue: 136126 },
  { city: "Baton Rouge, LA", metro: "Baton Rouge, LA", index: 90.8, state: "LA", incomeTaxTopRate: 3.0, salesTaxCombined: 10.11, propertyTaxRate: 0.55, medianHomeValue: 167369 },
  { city: "Waco, TX", metro: "Waco, TX", index: 90.8, state: "TX", incomeTaxTopRate: 0.0, salesTaxCombined: 8.2, propertyTaxRate: 1.4, medianHomeValue: 185771 },
  { city: "Montgomery, AL", metro: "Montgomery, AL", index: 90.8, state: "AL", incomeTaxTopRate: 5.0, salesTaxCombined: 9.46, propertyTaxRate: 0.37, medianHomeValue: 159660 },
  { city: "Oklahoma City, OK", metro: "Oklahoma City, OK", index: 91.0, state: "OK", incomeTaxTopRate: 4.5, salesTaxCombined: 9.06, propertyTaxRate: 0.79, medianHomeValue: 152013 },
  { city: "Fayetteville, AR", metro: "Fayetteville-Springdale-Rogers, AR", index: 91.0, state: "AR", incomeTaxTopRate: 3.9, salesTaxCombined: 9.46, propertyTaxRate: 0.56, medianHomeValue: 141465 },
  { city: "New Orleans, LA", metro: "New Orleans-Metairie, LA", index: 91.1, state: "LA", incomeTaxTopRate: 3.0, salesTaxCombined: 10.11, propertyTaxRate: 0.55, medianHomeValue: 167369 },
  { city: "Lincoln, NE", metro: "Lincoln, NE", index: 92.0, state: "NE", incomeTaxTopRate: 4.55, salesTaxCombined: 6.98, propertyTaxRate: 1.44, medianHomeValue: 164635 },
  { city: "Green Bay, WI", metro: "Green Bay, WI", index: 92.1, state: "WI", incomeTaxTopRate: 7.65, salesTaxCombined: 5.72, propertyTaxRate: 1.32, medianHomeValue: 234086 },
  { city: "Dayton, OH", metro: "Dayton-Kettering, OH", index: 92.3, state: "OH", incomeTaxTopRate: 2.75, salesTaxCombined: 7.29, propertyTaxRate: 1.36, medianHomeValue: 196325 },
  { city: "Memphis, TN", metro: "Memphis, TN-MS-AR", index: 92.4, state: "TN", incomeTaxTopRate: 0.0, salesTaxCombined: 9.61, propertyTaxRate: 0.52, medianHomeValue: 223385 },
  { city: "Omaha, NE", metro: "Omaha-Council Bluffs, NE-IA", index: 92.5, state: "NE", incomeTaxTopRate: 4.55, salesTaxCombined: 6.98, propertyTaxRate: 1.44, medianHomeValue: 164635 },
  { city: "Birmingham, AL", metro: "Birmingham-Hoover, AL", index: 92.6, state: "AL", incomeTaxTopRate: 5.0, salesTaxCombined: 9.46, propertyTaxRate: 0.37, medianHomeValue: 159660 },
  { city: "Des Moines, IA", metro: "Des Moines-West Des Moines, IA", index: 92.7, state: "IA", incomeTaxTopRate: 3.8, salesTaxCombined: 6.94, propertyTaxRate: 1.33, medianHomeValue: 171037 },
  { city: "Akron, OH", metro: "Akron, OH", index: 92.8, state: "OH", incomeTaxTopRate: 2.75, salesTaxCombined: 7.29, propertyTaxRate: 1.36, medianHomeValue: 196325 },
  { city: "Chattanooga, TN", metro: "Chattanooga, TN-GA", index: 92.8, state: "TN", incomeTaxTopRate: 0.0, salesTaxCombined: 9.61, propertyTaxRate: 0.52, medianHomeValue: 223385 },
  { city: "Greenville, SC", metro: "Greenville-Anderson, SC", index: 92.8, state: "SC", incomeTaxTopRate: 6.0, salesTaxCombined: 7.49, propertyTaxRate: 0.49, medianHomeValue: 199733 },
  { city: "Knoxville, TN", metro: "Knoxville, TN", index: 92.8, state: "TN", incomeTaxTopRate: 0.0, salesTaxCombined: 9.61, propertyTaxRate: 0.52, medianHomeValue: 223385 },
  { city: "Columbia, SC", metro: "Columbia, SC", index: 92.9, state: "SC", incomeTaxTopRate: 6.0, salesTaxCombined: 7.49, propertyTaxRate: 0.49, medianHomeValue: 199733 },
  { city: "Cleveland, OH", metro: "Cleveland-Elyria, OH", index: 93.0, state: "OH", incomeTaxTopRate: 2.75, salesTaxCombined: 7.29, propertyTaxRate: 1.36, medianHomeValue: 196325 },
  { city: "Albuquerque, NM", metro: "Albuquerque, NM", index: 93.0, state: "NM", incomeTaxTopRate: 5.9, salesTaxCombined: 7.67, propertyTaxRate: 0.63, medianHomeValue: 192727 },
  { city: "Lexington, KY", metro: "Lexington-Fayette, KY", index: 93.1, state: "KY", incomeTaxTopRate: 3.5, salesTaxCombined: 6.0, propertyTaxRate: 0.74, medianHomeValue: 160835 },
  { city: "Kansas City, MO", metro: "Kansas City, MO-KS", index: 93.3, state: "MO", incomeTaxTopRate: 4.7, salesTaxCombined: 8.44, propertyTaxRate: 0.89, medianHomeValue: 175712 },
  { city: "Boise, ID", metro: "Boise City, ID", index: 93.4, state: "ID", incomeTaxTopRate: 5.3, salesTaxCombined: 6.03, propertyTaxRate: 0.5, medianHomeValue: 355261 },
  { city: "Santa Fe, NM", metro: "Santa Fe, NM", index: 93.4, state: "NM", incomeTaxTopRate: 5.9, salesTaxCombined: 7.67, propertyTaxRate: 0.63, medianHomeValue: 192727 },
  { city: "San Antonio, TX", metro: "San Antonio-New Braunfels, TX", index: 93.7, state: "TX", incomeTaxTopRate: 0.0, salesTaxCombined: 8.2, propertyTaxRate: 1.4, medianHomeValue: 185771 },
  { city: "Louisville, KY", metro: "Louisville/Jefferson County, KY-IN", index: 94.0, state: "KY", incomeTaxTopRate: 3.5, salesTaxCombined: 6.0, propertyTaxRate: 0.74, medianHomeValue: 160835 },
  { city: "Cincinnati, OH", metro: "Cincinnati, OH-KY-IN", index: 94.1, state: "OH", incomeTaxTopRate: 2.75, salesTaxCombined: 7.29, propertyTaxRate: 1.36, medianHomeValue: 196325 },
  { city: "Tucson, AZ", metro: "Tucson, AZ", index: 94.3, state: "AZ", incomeTaxTopRate: 2.5, salesTaxCombined: 8.52, propertyTaxRate: 0.48, medianHomeValue: 265720 },
  { city: "Pittsburgh, PA", metro: "Pittsburgh, PA", index: 94.4, state: "PA", incomeTaxTopRate: 3.07, salesTaxCombined: 6.34, propertyTaxRate: 1.26, medianHomeValue: 212079 },
  { city: "Huntsville, AL", metro: "Huntsville, AL", index: 94.4, state: "AL", incomeTaxTopRate: 5.0, salesTaxCombined: 9.46, propertyTaxRate: 0.37, medianHomeValue: 159660 },
  { city: "Buffalo, NY", metro: "Buffalo-Cheektowaga, NY", index: 94.4, state: "NY", incomeTaxTopRate: 10.9, salesTaxCombined: 8.54, propertyTaxRate: 1.3, medianHomeValue: 281200 },
  { city: "Columbus, OH", metro: "Columbus, OH", index: 94.5, state: "OH", incomeTaxTopRate: 2.75, salesTaxCombined: 7.29, propertyTaxRate: 1.36, medianHomeValue: 196325 },
  { city: "Indianapolis, IN", metro: "Indianapolis-Carmel-Anderson, IN", index: 94.6, state: "IN", incomeTaxTopRate: 2.95, salesTaxCombined: 7.0, propertyTaxRate: 0.76, medianHomeValue: 191899 },
  { city: "Provo, UT", metro: "Provo-Orem, UT", index: 95.0, state: "UT", incomeTaxTopRate: 4.5, salesTaxCombined: 7.42, propertyTaxRate: 0.48, medianHomeValue: 418721 },
  { city: "Grand Rapids, MI", metro: "Grand Rapids-Kentwood, MI", index: 95.2, state: "MI", incomeTaxTopRate: 4.25, salesTaxCombined: 6.0, propertyTaxRate: 1.19, medianHomeValue: 197293 },
  { city: "Syracuse, NY", metro: "Syracuse, NY", index: 95.2, state: "NY", incomeTaxTopRate: 10.9, salesTaxCombined: 8.54, propertyTaxRate: 1.3, medianHomeValue: 281200 },
  { city: "Tallahassee, FL", metro: "Tallahassee, FL", index: 95.3, state: "FL", incomeTaxTopRate: 0.0, salesTaxCombined: 6.98, propertyTaxRate: 0.78, medianHomeValue: 284325 },
  { city: "Milwaukee, WI", metro: "Milwaukee-Waukesha, WI", index: 95.5, state: "WI", incomeTaxTopRate: 7.65, salesTaxCombined: 5.72, propertyTaxRate: 1.32, medianHomeValue: 234086 },
  { city: "Savannah, GA", metro: "Savannah, GA", index: 95.6, state: "GA", incomeTaxTopRate: 5.19, salesTaxCombined: 7.49, propertyTaxRate: 0.79, medianHomeValue: 198523 },
  { city: "Madison, WI", metro: "Madison, WI", index: 95.8, state: "WI", incomeTaxTopRate: 7.65, salesTaxCombined: 5.72, propertyTaxRate: 1.32, medianHomeValue: 234086 },
  { city: "Asheville, NC", metro: "Asheville, NC", index: 96.1, state: "NC", incomeTaxTopRate: 3.99, salesTaxCombined: 7.0, propertyTaxRate: 0.66, medianHomeValue: 235312 },
  { city: "St. Louis, MO", metro: "St. Louis, MO-IL", index: 96.3, state: "MO", incomeTaxTopRate: 4.7, salesTaxCombined: 8.44, propertyTaxRate: 0.89, medianHomeValue: 175712 },
  { city: "Salt Lake City, UT", metro: "Salt Lake City, UT", index: 96.4, state: "UT", incomeTaxTopRate: 4.5, salesTaxCombined: 7.42, propertyTaxRate: 0.48, medianHomeValue: 418721 },
  { city: "Durham, NC", metro: "Durham-Chapel Hill, NC", index: 96.6, state: "NC", incomeTaxTopRate: 3.99, salesTaxCombined: 7.0, propertyTaxRate: 0.66, medianHomeValue: 235312 },
  { city: "Fort Collins, CO", metro: "Fort Collins, CO", index: 96.6, state: "CO", incomeTaxTopRate: 4.4, salesTaxCombined: 7.89, propertyTaxRate: 0.5, medianHomeValue: 427513 },
  { city: "Gainesville, FL", metro: "Gainesville, FL", index: 96.9, state: "FL", incomeTaxTopRate: 0.0, salesTaxCombined: 6.98, propertyTaxRate: 0.78, medianHomeValue: 284325 },
  { city: "Charlotte, NC", metro: "Charlotte-Concord-Gastonia, NC-SC", index: 97.0, state: "NC", incomeTaxTopRate: 3.99, salesTaxCombined: 7.0, propertyTaxRate: 0.66, medianHomeValue: 235312 },
  { city: "Reno, NV", metro: "Reno, NV", index: 97.4, state: "NV", incomeTaxTopRate: 0.0, salesTaxCombined: 8.24, propertyTaxRate: 0.5, medianHomeValue: 306635 },
  { city: "Nashville, TN", metro: "Nashville-Davidson-Murfreesboro-Franklin, TN", index: 97.4, state: "TN", incomeTaxTopRate: 0.0, salesTaxCombined: 9.61, propertyTaxRate: 0.52, medianHomeValue: 223385 },
  { city: "Colorado Springs, CO", metro: "Colorado Springs, CO", index: 97.4, state: "CO", incomeTaxTopRate: 4.4, salesTaxCombined: 7.89, propertyTaxRate: 0.5, medianHomeValue: 427513 },
  { city: "Las Vegas, NV", metro: "Las Vegas-Henderson-Paradise, NV", index: 97.4, state: "NV", incomeTaxTopRate: 0.0, salesTaxCombined: 8.24, propertyTaxRate: 0.5, medianHomeValue: 306635 },
  { city: "Virginia Beach, VA", metro: "Virginia Beach-Norfolk-Newport News, VA-NC", index: 97.4, state: "VA", incomeTaxTopRate: 5.75, salesTaxCombined: 5.77, propertyTaxRate: 0.78, medianHomeValue: 295808 },
  { city: "Austin, TX", metro: "Austin-Round Rock-Georgetown, TX", index: 97.6, state: "TX", incomeTaxTopRate: 0.0, salesTaxCombined: 8.2, propertyTaxRate: 1.4, medianHomeValue: 185771 },
  { city: "Albany, NY", metro: "Albany-Schenectady-Troy, NY", index: 97.6, state: "NY", incomeTaxTopRate: 10.9, salesTaxCombined: 8.54, propertyTaxRate: 1.3, medianHomeValue: 281200 },
  { city: "Rochester, NY", metro: "Rochester, NY", index: 97.7, state: "NY", incomeTaxTopRate: 10.9, salesTaxCombined: 8.54, propertyTaxRate: 1.3, medianHomeValue: 281200 },
  { city: "Detroit, MI", metro: "Detroit-Warren-Dearborn, MI", index: 98.0, state: "MI", incomeTaxTopRate: 4.25, salesTaxCombined: 6.0, propertyTaxRate: 1.19, medianHomeValue: 197293 },
  { city: "Raleigh, NC", metro: "Raleigh-Cary, NC", index: 98.0, state: "NC", incomeTaxTopRate: 3.99, salesTaxCombined: 7.0, propertyTaxRate: 0.66, medianHomeValue: 235312 },
  { city: "Richmond, VA", metro: "Richmond, VA", index: 98.0, state: "VA", incomeTaxTopRate: 5.75, salesTaxCombined: 5.77, propertyTaxRate: 0.78, medianHomeValue: 295808 },
  { city: "Ann Arbor, MI", metro: "Ann Arbor, MI", index: 98.0, state: "MI", incomeTaxTopRate: 4.25, salesTaxCombined: 6.0, propertyTaxRate: 1.19, medianHomeValue: 197293 },
  { city: "Allentown, PA", metro: "Allentown-Bethlehem-Easton, PA-NJ", index: 98.4, state: "PA", incomeTaxTopRate: 3.07, salesTaxCombined: 6.34, propertyTaxRate: 1.26, medianHomeValue: 212079 },
  { city: "Springfield, MA", metro: "Springfield, MA", index: 98.4, state: "MA", incomeTaxTopRate: 9.0, salesTaxCombined: 6.25, propertyTaxRate: 1.0, medianHomeValue: 634257 },
  { city: "Charlottesville, VA", metro: "Charlottesville, VA", index: 98.6, state: "VA", incomeTaxTopRate: 5.75, salesTaxCombined: 5.77, propertyTaxRate: 0.78, medianHomeValue: 295808 },
  { city: "Jacksonville, FL", metro: "Jacksonville, FL", index: 99.2, state: "FL", incomeTaxTopRate: 0.0, salesTaxCombined: 6.98, propertyTaxRate: 0.78, medianHomeValue: 284325 },
  { city: "Boulder, CO", metro: "Boulder, CO", index: 99.9, state: "CO", incomeTaxTopRate: 4.4, salesTaxCombined: 7.89, propertyTaxRate: 0.5, medianHomeValue: 427513 },
  { city: "Burlington, VT", metro: "Burlington-South Burlington, VT", index: 100.0, state: "VT", incomeTaxTopRate: 8.75, salesTaxCombined: 6.39, propertyTaxRate: 1.51, medianHomeValue: 292950 },
  { city: "Houston, TX", metro: "Houston-The Woodlands-Sugar Land, TX", index: 100.2, state: "TX", incomeTaxTopRate: 0.0, salesTaxCombined: 8.2, propertyTaxRate: 1.4, medianHomeValue: 185771 },
  { city: "Charleston, SC", metro: "Charleston-North Charleston, SC", index: 100.6, state: "SC", incomeTaxTopRate: 6.0, salesTaxCombined: 7.49, propertyTaxRate: 0.49, medianHomeValue: 199733 },
  { city: "Atlanta, GA", metro: "Atlanta-Sandy Springs-Alpharetta, GA", index: 100.9, state: "GA", incomeTaxTopRate: 5.19, salesTaxCombined: 7.49, propertyTaxRate: 0.79, medianHomeValue: 198523 },
  { city: "Providence, RI", metro: "Providence-Warwick, RI-MA", index: 100.9, state: "RI", incomeTaxTopRate: 5.99, salesTaxCombined: 7.0, propertyTaxRate: 1.12, medianHomeValue: 474800 },
  { city: "Spokane, WA", metro: "Spokane-Spokane Valley, WA", index: 101.0, state: "WA", incomeTaxTopRate: 0.0, salesTaxCombined: 9.51, propertyTaxRate: 0.75, medianHomeValue: 436313 },
  { city: "Orlando, FL", metro: "Orlando-Kissimmee-Sanford, FL", index: 101.1, state: "FL", incomeTaxTopRate: 0.0, salesTaxCombined: 6.98, propertyTaxRate: 0.78, medianHomeValue: 284325 },
  { city: "Port St. Lucie, FL", metro: "Port St. Lucie, FL", index: 101.7, state: "FL", incomeTaxTopRate: 0.0, salesTaxCombined: 6.98, propertyTaxRate: 0.78, medianHomeValue: 284325 },
  { city: "Worcester, MA", metro: "Worcester, MA-CT", index: 102.0, state: "MA", incomeTaxTopRate: 9.0, salesTaxCombined: 6.25, propertyTaxRate: 1.0, medianHomeValue: 634257 },
  { city: "Trenton, NJ", metro: "Trenton-Princeton, NJ", index: 102.1, state: "NJ", incomeTaxTopRate: 10.75, salesTaxCombined: 6.6, propertyTaxRate: 1.88, medianHomeValue: 430014 },
  { city: "Bakersfield, CA", metro: "Bakersfield, CA", index: 102.2, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "Hartford, CT", metro: "Hartford-East Hartford-Middletown, CT", index: 102.6, state: "CT", incomeTaxTopRate: 6.99, salesTaxCombined: 6.35, propertyTaxRate: 1.54, medianHomeValue: 380278 },
  { city: "Fort Myers, FL", metro: "Cape Coral-Fort Myers, FL", index: 102.6, state: "FL", incomeTaxTopRate: 0.0, salesTaxCombined: 6.98, propertyTaxRate: 0.78, medianHomeValue: 284325 },
  { city: "Chicago, IL", metro: "Chicago-Naperville-Elgin, IL-IN-WI", index: 102.6, state: "IL", incomeTaxTopRate: 4.95, salesTaxCombined: 8.96, propertyTaxRate: 1.88, medianHomeValue: 153020 },
  { city: "Baltimore, MD", metro: "Baltimore-Columbia-Towson, MD", index: 102.7, state: "MD", incomeTaxTopRate: 6.5, salesTaxCombined: 6.0, propertyTaxRate: 0.92, medianHomeValue: 370017 },
  { city: "Dallas, TX", metro: "Dallas-Fort Worth-Arlington, TX", index: 103.3, state: "TX", incomeTaxTopRate: 0.0, salesTaxCombined: 8.2, propertyTaxRate: 1.4, medianHomeValue: 185771 },
  { city: "Tampa, FL", metro: "Tampa-St. Petersburg-Clearwater, FL", index: 103.4, state: "FL", incomeTaxTopRate: 0.0, salesTaxCombined: 6.98, propertyTaxRate: 0.78, medianHomeValue: 284325 },
  { city: "New Haven, CT", metro: "New Haven-Milford, CT", index: 103.5, state: "CT", incomeTaxTopRate: 6.99, salesTaxCombined: 6.35, propertyTaxRate: 1.54, medianHomeValue: 380278 },
  { city: "Eugene, OR", metro: "Eugene-Springfield, OR", index: 103.5, state: "OR", incomeTaxTopRate: 9.9, salesTaxCombined: 0.0, propertyTaxRate: 0.81, medianHomeValue: 386692 },
  { city: "Sarasota, FL", metro: "North Port-Sarasota-Bradenton, FL", index: 103.6, state: "FL", incomeTaxTopRate: 0.0, salesTaxCombined: 6.98, propertyTaxRate: 0.78, medianHomeValue: 284325 },
  { city: "Portland, ME", metro: "Portland-South Portland, ME", index: 103.6, state: "ME", incomeTaxTopRate: 7.15, salesTaxCombined: 5.5, propertyTaxRate: 0.98, medianHomeValue: 260725 },
  { city: "Philadelphia, PA", metro: "Philadelphia-Camden-Wilmington, PA-NJ-DE-MD", index: 103.6, state: "PA", incomeTaxTopRate: 3.07, salesTaxCombined: 6.34, propertyTaxRate: 1.26, medianHomeValue: 212079 },
  { city: "Fresno, CA", metro: "Fresno, CA", index: 104.0, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "Anchorage, AK", metro: "Anchorage, AK", index: 104.5, state: "AK", incomeTaxTopRate: 0.0, salesTaxCombined: 1.82, propertyTaxRate: 0.94, medianHomeValue: 295450 },
  { city: "Minneapolis, MN", metro: "Minneapolis-St. Paul-Bloomington, MN-WI", index: 104.5, state: "MN", incomeTaxTopRate: 9.85, salesTaxCombined: 8.14, propertyTaxRate: 1.0, medianHomeValue: 238336 },
  { city: "Manchester, NH", metro: "Manchester-Nashua, NH", index: 105.1, state: "NH", incomeTaxTopRate: 0.0, salesTaxCombined: 0.0, propertyTaxRate: 1.5, medianHomeValue: 349500 },
  { city: "Phoenix, AZ", metro: "Phoenix-Mesa-Chandler, AZ", index: 105.5, state: "AZ", incomeTaxTopRate: 2.5, salesTaxCombined: 8.52, propertyTaxRate: 0.48, medianHomeValue: 265720 },
  { city: "Denver, CO", metro: "Denver-Aurora-Lakewood, CO", index: 105.5, state: "CO", incomeTaxTopRate: 4.4, salesTaxCombined: 7.89, propertyTaxRate: 0.5, medianHomeValue: 427513 },
  { city: "Naples, FL", metro: "Naples-Marco Island, FL", index: 105.8, state: "FL", incomeTaxTopRate: 0.0, salesTaxCombined: 6.98, propertyTaxRate: 0.78, medianHomeValue: 284325 },
  { city: "Bend, OR", metro: "Bend, OR", index: 105.8, state: "OR", incomeTaxTopRate: 9.9, salesTaxCombined: 0.0, propertyTaxRate: 0.81, medianHomeValue: 386692 },
  { city: "Bridgeport, CT", metro: "Bridgeport-Stamford-Norwalk, CT", index: 106.5, state: "CT", incomeTaxTopRate: 6.99, salesTaxCombined: 6.35, propertyTaxRate: 1.54, medianHomeValue: 380278 },
  { city: "Portland, OR", metro: "Portland-Vancouver-Hillsboro, OR-WA", index: 106.6, state: "OR", incomeTaxTopRate: 9.9, salesTaxCombined: 0.0, propertyTaxRate: 0.81, medianHomeValue: 386692 },
  { city: "Stockton, CA", metro: "Stockton, CA", index: 107.4, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "Riverside, CA", metro: "Riverside-San Bernardino-Ontario, CA", index: 107.9, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "Washington, DC", metro: "Washington-Arlington-Alexandria, DC-VA-MD-WV", index: 108.6, state: "DC", incomeTaxTopRate: 10.75, salesTaxCombined: 6.0, propertyTaxRate: 0.6, medianHomeValue: 737100 },
  { city: "Sacramento, CA", metro: "Sacramento-Roseville-Folsom, CA", index: 108.9, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "Santa Rosa, CA", metro: "Santa Rosa-Petaluma, CA", index: 110.1, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "Honolulu, HI", metro: "Urban Honolulu, HI", index: 110.2, state: "HI", incomeTaxTopRate: 11.0, salesTaxCombined: 4.5, propertyTaxRate: 0.29, medianHomeValue: 798675 },
  { city: "San Luis Obispo, CA", metro: "San Luis Obispo-Paso Robles, CA", index: 110.8, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "San Diego, CA", metro: "San Diego-Chula Vista-Carlsbad, CA", index: 111.5, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "Boston, MA", metro: "Boston-Cambridge-Newton, MA-NH", index: 111.6, state: "MA", incomeTaxTopRate: 9.0, salesTaxCombined: 6.25, propertyTaxRate: 1.0, medianHomeValue: 634257 },
  { city: "Miami, FL", metro: "Miami-Fort Lauderdale-Pompano Beach, FL", index: 111.8, state: "FL", incomeTaxTopRate: 0.0, salesTaxCombined: 6.98, propertyTaxRate: 0.78, medianHomeValue: 284325 },
  { city: "New York, NY", metro: "New York-Newark-Jersey City, NY-NJ-PA", index: 112.5, state: "NY", incomeTaxTopRate: 10.9, salesTaxCombined: 8.54, propertyTaxRate: 1.3, medianHomeValue: 281200 },
  { city: "Santa Cruz, CA", metro: "Santa Cruz-Watsonville, CA", index: 112.6, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "San Jose, CA", metro: "San Jose-Sunnyvale-Santa Clara, CA", index: 112.9, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "Seattle, WA", metro: "Seattle-Tacoma-Bellevue, WA", index: 113.0, state: "WA", incomeTaxTopRate: 0.0, salesTaxCombined: 9.51, propertyTaxRate: 0.75, medianHomeValue: 436313 },
  { city: "Santa Barbara, CA", metro: "Santa Maria-Santa Barbara, CA", index: 113.5, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "Oxnard, CA", metro: "Oxnard-Thousand Oaks-Ventura, CA", index: 113.5, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "Los Angeles, CA", metro: "Los Angeles-Long Beach-Anaheim, CA", index: 115.5, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
  { city: "San Francisco, CA", metro: "San Francisco-Oakland-Berkeley, CA", index: 118.2, state: "CA", incomeTaxTopRate: 13.3, salesTaxCombined: 8.99, propertyTaxRate: 0.7, medianHomeValue: 604112 },
];

// Maps a ZIP code's first 3 digits to the nearest of the 127 metros above,
// built from the real USPS ZIP3-prefix-to-state structure, then assigned
// to the geographically nearest covered metro within each state. Not
// available for states with no metro in the 127-city list above (e.g.
// Delaware, Montana, North Dakota, West Virginia, Wyoming) -- those ZIPs
// simply return no match, same as an unrecognized city name.
const ZIP3_TO_CITY: Record<string, string> = {
  "005": "New York, NY",
  "010": "Springfield, MA",
  "011": "Springfield, MA",
  "012": "Springfield, MA",
  "013": "Springfield, MA",
  "014": "Springfield, MA",
  "015": "Worcester, MA",
  "016": "Worcester, MA",
  "017": "Springfield, MA",
  "018": "Springfield, MA",
  "019": "Springfield, MA",
  "020": "Boston, MA",
  "021": "Boston, MA",
  "022": "Boston, MA",
  "023": "Boston, MA",
  "024": "Boston, MA",
  "025": "Boston, MA",
  "026": "Boston, MA",
  "027": "Boston, MA",
  "028": "Providence, RI",
  "029": "Providence, RI",
  "030": "Manchester, NH",
  "031": "Manchester, NH",
  "032": "Manchester, NH",
  "033": "Manchester, NH",
  "034": "Manchester, NH",
  "035": "Manchester, NH",
  "036": "Manchester, NH",
  "037": "Manchester, NH",
  "038": "Manchester, NH",
  "039": "Portland, ME",
  "040": "Portland, ME",
  "041": "Portland, ME",
  "042": "Portland, ME",
  "043": "Portland, ME",
  "044": "Portland, ME",
  "045": "Portland, ME",
  "046": "Portland, ME",
  "047": "Portland, ME",
  "048": "Portland, ME",
  "049": "Portland, ME",
  "050": "Burlington, VT",
  "051": "Burlington, VT",
  "052": "Burlington, VT",
  "053": "Burlington, VT",
  "054": "Burlington, VT",
  "055": "Boston, MA",
  "056": "Burlington, VT",
  "057": "Burlington, VT",
  "058": "Burlington, VT",
  "059": "Burlington, VT",
  "060": "Hartford, CT",
  "061": "Hartford, CT",
  "062": "Hartford, CT",
  "063": "New Haven, CT",
  "064": "New Haven, CT",
  "065": "Hartford, CT",
  "066": "Hartford, CT",
  "067": "Hartford, CT",
  "068": "Bridgeport, CT",
  "069": "Bridgeport, CT",
  "070": "Trenton, NJ",
  "071": "Trenton, NJ",
  "072": "Trenton, NJ",
  "073": "Trenton, NJ",
  "074": "Trenton, NJ",
  "075": "Trenton, NJ",
  "076": "Trenton, NJ",
  "077": "Trenton, NJ",
  "078": "Trenton, NJ",
  "079": "Trenton, NJ",
  "080": "Trenton, NJ",
  "081": "Trenton, NJ",
  "082": "Trenton, NJ",
  "083": "Trenton, NJ",
  "084": "Trenton, NJ",
  "085": "Trenton, NJ",
  "086": "Trenton, NJ",
  "087": "Trenton, NJ",
  "088": "Trenton, NJ",
  "089": "Trenton, NJ",
  "100": "New York, NY",
  "101": "New York, NY",
  "102": "New York, NY",
  "103": "New York, NY",
  "104": "New York, NY",
  "105": "New York, NY",
  "106": "New York, NY",
  "107": "New York, NY",
  "108": "New York, NY",
  "109": "New York, NY",
  "110": "New York, NY",
  "111": "New York, NY",
  "112": "New York, NY",
  "113": "New York, NY",
  "114": "New York, NY",
  "115": "New York, NY",
  "116": "New York, NY",
  "117": "New York, NY",
  "118": "New York, NY",
  "119": "New York, NY",
  "120": "Albany, NY",
  "121": "Albany, NY",
  "122": "Albany, NY",
  "123": "Albany, NY",
  "124": "Albany, NY",
  "125": "Albany, NY",
  "126": "Albany, NY",
  "127": "Albany, NY",
  "128": "Albany, NY",
  "129": "Albany, NY",
  "130": "Syracuse, NY",
  "131": "Syracuse, NY",
  "132": "Syracuse, NY",
  "133": "Syracuse, NY",
  "134": "Syracuse, NY",
  "135": "Syracuse, NY",
  "136": "Syracuse, NY",
  "137": "Syracuse, NY",
  "138": "Syracuse, NY",
  "139": "Syracuse, NY",
  "140": "Buffalo, NY",
  "141": "Buffalo, NY",
  "142": "Buffalo, NY",
  "143": "Buffalo, NY",
  "144": "Buffalo, NY",
  "145": "Rochester, NY",
  "146": "Rochester, NY",
  "147": "Rochester, NY",
  "148": "Rochester, NY",
  "149": "Rochester, NY",
  "150": "Pittsburgh, PA",
  "151": "Pittsburgh, PA",
  "152": "Pittsburgh, PA",
  "153": "Pittsburgh, PA",
  "154": "Pittsburgh, PA",
  "155": "Pittsburgh, PA",
  "156": "Pittsburgh, PA",
  "157": "Pittsburgh, PA",
  "158": "Pittsburgh, PA",
  "159": "Pittsburgh, PA",
  "160": "Pittsburgh, PA",
  "161": "Allentown, PA",
  "162": "Allentown, PA",
  "163": "Allentown, PA",
  "164": "Allentown, PA",
  "165": "Allentown, PA",
  "166": "Allentown, PA",
  "167": "Allentown, PA",
  "168": "Allentown, PA",
  "169": "Allentown, PA",
  "170": "Allentown, PA",
  "171": "Allentown, PA",
  "172": "Allentown, PA",
  "173": "Allentown, PA",
  "174": "Allentown, PA",
  "175": "Allentown, PA",
  "176": "Allentown, PA",
  "177": "Allentown, PA",
  "178": "Allentown, PA",
  "179": "Allentown, PA",
  "180": "Allentown, PA",
  "181": "Allentown, PA",
  "182": "Allentown, PA",
  "183": "Allentown, PA",
  "184": "Allentown, PA",
  "185": "Allentown, PA",
  "186": "Allentown, PA",
  "187": "Allentown, PA",
  "188": "Allentown, PA",
  "189": "Allentown, PA",
  "190": "Philadelphia, PA",
  "191": "Philadelphia, PA",
  "193": "Philadelphia, PA",
  "194": "Philadelphia, PA",
  "195": "Philadelphia, PA",
  "196": "Philadelphia, PA",
  "200": "Washington, DC",
  "201": "Washington, DC",
  "202": "Washington, DC",
  "203": "Washington, DC",
  "204": "Washington, DC",
  "205": "Washington, DC",
  "206": "Baltimore, MD",
  "207": "Baltimore, MD",
  "208": "Baltimore, MD",
  "209": "Baltimore, MD",
  "210": "Baltimore, MD",
  "211": "Baltimore, MD",
  "212": "Baltimore, MD",
  "214": "Baltimore, MD",
  "215": "Baltimore, MD",
  "216": "Baltimore, MD",
  "217": "Baltimore, MD",
  "218": "Baltimore, MD",
  "219": "Baltimore, MD",
  "220": "Washington, DC",
  "221": "Washington, DC",
  "222": "Washington, DC",
  "223": "Washington, DC",
  "224": "Charlottesville, VA",
  "225": "Charlottesville, VA",
  "226": "Charlottesville, VA",
  "227": "Washington, DC",
  "228": "Washington, DC",
  "229": "Washington, DC",
  "230": "Richmond, VA",
  "231": "Richmond, VA",
  "232": "Richmond, VA",
  "233": "Virginia Beach, VA",
  "234": "Virginia Beach, VA",
  "235": "Virginia Beach, VA",
  "236": "Virginia Beach, VA",
  "237": "Richmond, VA",
  "238": "Richmond, VA",
  "239": "Richmond, VA",
  "240": "Richmond, VA",
  "241": "Richmond, VA",
  "242": "Richmond, VA",
  "243": "Richmond, VA",
  "244": "Richmond, VA",
  "245": "Richmond, VA",
  "246": "Richmond, VA",
  "270": "Raleigh, NC",
  "271": "Raleigh, NC",
  "272": "Raleigh, NC",
  "273": "Durham, NC",
  "274": "Durham, NC",
  "275": "Raleigh, NC",
  "276": "Charlotte, NC",
  "277": "Charlotte, NC",
  "278": "Charlotte, NC",
  "279": "Charlotte, NC",
  "280": "Charlotte, NC",
  "281": "Charlotte, NC",
  "282": "Charlotte, NC",
  "283": "Asheville, NC",
  "284": "Asheville, NC",
  "285": "Asheville, NC",
  "286": "Asheville, NC",
  "287": "Asheville, NC",
  "288": "Asheville, NC",
  "289": "Asheville, NC",
  "290": "Columbia, SC",
  "291": "Columbia, SC",
  "292": "Columbia, SC",
  "293": "Greenville, SC",
  "294": "Greenville, SC",
  "295": "Charleston, SC",
  "296": "Charleston, SC",
  "297": "Charleston, SC",
  "298": "Charleston, SC",
  "299": "Charleston, SC",
  "300": "Atlanta, GA",
  "301": "Atlanta, GA",
  "302": "Atlanta, GA",
  "303": "Atlanta, GA",
  "304": "Atlanta, GA",
  "305": "Atlanta, GA",
  "306": "Atlanta, GA",
  "307": "Atlanta, GA",
  "308": "Atlanta, GA",
  "309": "Atlanta, GA",
  "310": "Savannah, GA",
  "311": "Savannah, GA",
  "312": "Savannah, GA",
  "313": "Savannah, GA",
  "314": "Savannah, GA",
  "315": "Savannah, GA",
  "316": "Savannah, GA",
  "317": "Savannah, GA",
  "318": "Savannah, GA",
  "319": "Savannah, GA",
  "320": "Jacksonville, FL",
  "321": "Jacksonville, FL",
  "322": "Gainesville, FL",
  "323": "Tallahassee, FL",
  "324": "Tallahassee, FL",
  "325": "Tallahassee, FL",
  "326": "Gainesville, FL",
  "327": "Orlando, FL",
  "328": "Orlando, FL",
  "329": "Orlando, FL",
  "330": "Miami, FL",
  "331": "Miami, FL",
  "332": "Miami, FL",
  "333": "Miami, FL",
  "334": "Miami, FL",
  "335": "Sarasota, FL",
  "336": "Tampa, FL",
  "337": "Tampa, FL",
  "338": "Orlando, FL",
  "339": "Sarasota, FL",
  "341": "Sarasota, FL",
  "342": "Fort Myers, FL",
  "344": "Fort Myers, FL",
  "346": "Naples, FL",
  "347": "Miami, FL",
  "349": "Port St. Lucie, FL",
  "350": "Birmingham, AL",
  "351": "Birmingham, AL",
  "352": "Birmingham, AL",
  "354": "Huntsville, AL",
  "355": "Huntsville, AL",
  "356": "Huntsville, AL",
  "357": "Birmingham, AL",
  "358": "Birmingham, AL",
  "359": "Birmingham, AL",
  "360": "Birmingham, AL",
  "361": "Montgomery, AL",
  "362": "Montgomery, AL",
  "363": "Mobile, AL",
  "364": "Mobile, AL",
  "365": "Mobile, AL",
  "366": "Mobile, AL",
  "367": "Mobile, AL",
  "368": "Mobile, AL",
  "369": "Mobile, AL",
  "370": "Nashville, TN",
  "371": "Nashville, TN",
  "372": "Nashville, TN",
  "373": "Chattanooga, TN",
  "374": "Chattanooga, TN",
  "376": "Chattanooga, TN",
  "377": "Chattanooga, TN",
  "378": "Chattanooga, TN",
  "379": "Chattanooga, TN",
  "380": "Memphis, TN",
  "381": "Memphis, TN",
  "382": "Knoxville, TN",
  "383": "Knoxville, TN",
  "384": "Knoxville, TN",
  "385": "Knoxville, TN",
  "386": "Jackson, MS",
  "387": "Jackson, MS",
  "388": "Jackson, MS",
  "389": "Jackson, MS",
  "390": "Jackson, MS",
  "391": "Jackson, MS",
  "392": "Jackson, MS",
  "393": "Jackson, MS",
  "394": "Jackson, MS",
  "395": "Jackson, MS",
  "396": "Jackson, MS",
  "397": "Jackson, MS",
  "398": "Savannah, GA",
  "400": "Louisville, KY",
  "401": "Louisville, KY",
  "402": "Louisville, KY",
  "403": "Louisville, KY",
  "404": "Louisville, KY",
  "405": "Louisville, KY",
  "406": "Louisville, KY",
  "407": "Louisville, KY",
  "408": "Louisville, KY",
  "409": "Louisville, KY",
  "410": "Lexington, KY",
  "411": "Lexington, KY",
  "412": "Lexington, KY",
  "413": "Lexington, KY",
  "414": "Lexington, KY",
  "415": "Lexington, KY",
  "416": "Lexington, KY",
  "417": "Lexington, KY",
  "418": "Lexington, KY",
  "420": "Louisville, KY",
  "421": "Louisville, KY",
  "422": "Louisville, KY",
  "423": "Louisville, KY",
  "424": "Louisville, KY",
  "425": "Louisville, KY",
  "426": "Louisville, KY",
  "427": "Louisville, KY",
  "430": "Columbus, OH",
  "431": "Columbus, OH",
  "432": "Columbus, OH",
  "433": "Toledo, OH",
  "434": "Toledo, OH",
  "435": "Toledo, OH",
  "436": "Toledo, OH",
  "437": "Toledo, OH",
  "438": "Toledo, OH",
  "439": "Toledo, OH",
  "440": "Cleveland, OH",
  "441": "Cleveland, OH",
  "442": "Akron, OH",
  "443": "Akron, OH",
  "444": "Akron, OH",
  "445": "Cleveland, OH",
  "446": "Cleveland, OH",
  "447": "Cleveland, OH",
  "448": "Akron, OH",
  "449": "Akron, OH",
  "450": "Cincinnati, OH",
  "451": "Cincinnati, OH",
  "452": "Cincinnati, OH",
  "453": "Dayton, OH",
  "454": "Dayton, OH",
  "455": "Dayton, OH",
  "456": "Dayton, OH",
  "457": "Dayton, OH",
  "458": "Dayton, OH",
  "460": "Indianapolis, IN",
  "461": "Indianapolis, IN",
  "462": "Indianapolis, IN",
  "463": "Indianapolis, IN",
  "464": "Indianapolis, IN",
  "465": "Indianapolis, IN",
  "466": "Indianapolis, IN",
  "467": "Indianapolis, IN",
  "468": "Indianapolis, IN",
  "469": "Indianapolis, IN",
  "470": "Fort Wayne, IN",
  "471": "Fort Wayne, IN",
  "472": "Fort Wayne, IN",
  "473": "Fort Wayne, IN",
  "474": "Fort Wayne, IN",
  "475": "Fort Wayne, IN",
  "476": "Fort Wayne, IN",
  "477": "Fort Wayne, IN",
  "478": "Fort Wayne, IN",
  "479": "Fort Wayne, IN",
  "480": "Detroit, MI",
  "481": "Detroit, MI",
  "482": "Flint, MI",
  "483": "Flint, MI",
  "484": "Flint, MI",
  "485": "Ann Arbor, MI",
  "486": "Ann Arbor, MI",
  "487": "Ann Arbor, MI",
  "488": "Detroit, MI",
  "489": "Detroit, MI",
  "490": "Grand Rapids, MI",
  "491": "Grand Rapids, MI",
  "492": "Grand Rapids, MI",
  "493": "Grand Rapids, MI",
  "494": "Grand Rapids, MI",
  "495": "Grand Rapids, MI",
  "496": "Grand Rapids, MI",
  "497": "Grand Rapids, MI",
  "498": "Grand Rapids, MI",
  "499": "Grand Rapids, MI",
  "500": "Des Moines, IA",
  "501": "Des Moines, IA",
  "502": "Des Moines, IA",
  "503": "Des Moines, IA",
  "504": "Des Moines, IA",
  "505": "Des Moines, IA",
  "506": "Des Moines, IA",
  "507": "Des Moines, IA",
  "508": "Des Moines, IA",
  "510": "Des Moines, IA",
  "511": "Des Moines, IA",
  "512": "Des Moines, IA",
  "513": "Des Moines, IA",
  "514": "Des Moines, IA",
  "515": "Des Moines, IA",
  "516": "Des Moines, IA",
  "520": "Des Moines, IA",
  "521": "Des Moines, IA",
  "522": "Des Moines, IA",
  "523": "Des Moines, IA",
  "524": "Des Moines, IA",
  "525": "Des Moines, IA",
  "526": "Des Moines, IA",
  "527": "Des Moines, IA",
  "528": "Des Moines, IA",
  "530": "Milwaukee, WI",
  "531": "Milwaukee, WI",
  "532": "Milwaukee, WI",
  "534": "Madison, WI",
  "535": "Madison, WI",
  "537": "Madison, WI",
  "538": "Madison, WI",
  "539": "Madison, WI",
  "540": "Green Bay, WI",
  "541": "Green Bay, WI",
  "542": "Green Bay, WI",
  "543": "Green Bay, WI",
  "544": "Green Bay, WI",
  "545": "Green Bay, WI",
  "546": "Green Bay, WI",
  "547": "Green Bay, WI",
  "548": "Green Bay, WI",
  "549": "Green Bay, WI",
  "550": "Minneapolis, MN",
  "551": "Minneapolis, MN",
  "553": "Minneapolis, MN",
  "554": "Minneapolis, MN",
  "555": "Minneapolis, MN",
  "556": "Minneapolis, MN",
  "557": "Minneapolis, MN",
  "558": "Minneapolis, MN",
  "559": "Minneapolis, MN",
  "560": "Minneapolis, MN",
  "561": "Minneapolis, MN",
  "562": "Minneapolis, MN",
  "563": "Minneapolis, MN",
  "564": "Minneapolis, MN",
  "565": "Minneapolis, MN",
  "566": "Minneapolis, MN",
  "567": "Minneapolis, MN",
  "569": "Washington, DC",
  "570": "Sioux Falls, SD",
  "571": "Sioux Falls, SD",
  "572": "Sioux Falls, SD",
  "573": "Sioux Falls, SD",
  "574": "Sioux Falls, SD",
  "575": "Sioux Falls, SD",
  "576": "Sioux Falls, SD",
  "577": "Sioux Falls, SD",
  "600": "Chicago, IL",
  "601": "Chicago, IL",
  "602": "Chicago, IL",
  "603": "Chicago, IL",
  "604": "Chicago, IL",
  "605": "Chicago, IL",
  "606": "Chicago, IL",
  "607": "Chicago, IL",
  "608": "Chicago, IL",
  "609": "Rockford, IL",
  "610": "Rockford, IL",
  "611": "Rockford, IL",
  "612": "Rockford, IL",
  "613": "Rockford, IL",
  "614": "Rockford, IL",
  "615": "Rockford, IL",
  "616": "Rockford, IL",
  "617": "Rockford, IL",
  "618": "Rockford, IL",
  "619": "Rockford, IL",
  "620": "Rockford, IL",
  "622": "Rockford, IL",
  "623": "Rockford, IL",
  "624": "Rockford, IL",
  "625": "Rockford, IL",
  "626": "Rockford, IL",
  "627": "Rockford, IL",
  "628": "Rockford, IL",
  "629": "Rockford, IL",
  "630": "St. Louis, MO",
  "631": "St. Louis, MO",
  "633": "Springfield, MO",
  "634": "Springfield, MO",
  "635": "Springfield, MO",
  "636": "Springfield, MO",
  "637": "Springfield, MO",
  "638": "Springfield, MO",
  "639": "Springfield, MO",
  "640": "Kansas City, MO",
  "641": "Kansas City, MO",
  "644": "Kansas City, MO",
  "645": "Kansas City, MO",
  "646": "Kansas City, MO",
  "647": "Kansas City, MO",
  "648": "Kansas City, MO",
  "650": "Kansas City, MO",
  "651": "Kansas City, MO",
  "652": "Kansas City, MO",
  "653": "Kansas City, MO",
  "654": "Kansas City, MO",
  "655": "Kansas City, MO",
  "656": "Kansas City, MO",
  "657": "Kansas City, MO",
  "658": "Kansas City, MO",
  "660": "Wichita, KS",
  "661": "Wichita, KS",
  "662": "Wichita, KS",
  "664": "Wichita, KS",
  "665": "Wichita, KS",
  "666": "Wichita, KS",
  "667": "Wichita, KS",
  "668": "Wichita, KS",
  "669": "Wichita, KS",
  "670": "Wichita, KS",
  "671": "Wichita, KS",
  "672": "Wichita, KS",
  "673": "Wichita, KS",
  "674": "Wichita, KS",
  "675": "Wichita, KS",
  "676": "Wichita, KS",
  "677": "Wichita, KS",
  "678": "Wichita, KS",
  "679": "Wichita, KS",
  "680": "Omaha, NE",
  "681": "Omaha, NE",
  "683": "Lincoln, NE",
  "684": "Lincoln, NE",
  "685": "Lincoln, NE",
  "686": "Lincoln, NE",
  "687": "Lincoln, NE",
  "688": "Lincoln, NE",
  "689": "Lincoln, NE",
  "690": "Lincoln, NE",
  "691": "Lincoln, NE",
  "692": "Lincoln, NE",
  "693": "Lincoln, NE",
  "700": "New Orleans, LA",
  "701": "New Orleans, LA",
  "703": "New Orleans, LA",
  "704": "New Orleans, LA",
  "705": "New Orleans, LA",
  "706": "New Orleans, LA",
  "707": "New Orleans, LA",
  "708": "New Orleans, LA",
  "710": "Baton Rouge, LA",
  "711": "Shreveport, LA",
  "712": "Shreveport, LA",
  "713": "Shreveport, LA",
  "714": "Shreveport, LA",
  "716": "Little Rock, AR",
  "717": "Little Rock, AR",
  "718": "Little Rock, AR",
  "719": "Little Rock, AR",
  "720": "Little Rock, AR",
  "721": "Little Rock, AR",
  "722": "Little Rock, AR",
  "723": "Little Rock, AR",
  "724": "Fayetteville, AR",
  "725": "Fayetteville, AR",
  "726": "Fayetteville, AR",
  "727": "Fayetteville, AR",
  "728": "Fayetteville, AR",
  "729": "Fayetteville, AR",
  "730": "Oklahoma City, OK",
  "731": "Oklahoma City, OK",
  "734": "Oklahoma City, OK",
  "735": "Oklahoma City, OK",
  "736": "Oklahoma City, OK",
  "737": "Oklahoma City, OK",
  "738": "Oklahoma City, OK",
  "739": "Oklahoma City, OK",
  "740": "Oklahoma City, OK",
  "741": "Oklahoma City, OK",
  "743": "Tulsa, OK",
  "744": "Tulsa, OK",
  "745": "Tulsa, OK",
  "746": "Tulsa, OK",
  "747": "Tulsa, OK",
  "748": "Tulsa, OK",
  "749": "Tulsa, OK",
  "750": "Dallas, TX",
  "751": "Dallas, TX",
  "752": "Dallas, TX",
  "753": "Dallas, TX",
  "754": "Waco, TX",
  "755": "Waco, TX",
  "756": "Waco, TX",
  "757": "Waco, TX",
  "758": "Waco, TX",
  "759": "Waco, TX",
  "760": "Dallas, TX",
  "761": "Dallas, TX",
  "762": "Dallas, TX",
  "763": "Dallas, TX",
  "764": "Dallas, TX",
  "765": "Waco, TX",
  "766": "Waco, TX",
  "767": "Waco, TX",
  "768": "Waco, TX",
  "769": "Waco, TX",
  "770": "Houston, TX",
  "771": "Houston, TX",
  "772": "Houston, TX",
  "773": "Houston, TX",
  "774": "Houston, TX",
  "775": "Houston, TX",
  "776": "Houston, TX",
  "777": "Houston, TX",
  "778": "Austin, TX",
  "779": "Austin, TX",
  "780": "San Antonio, TX",
  "781": "San Antonio, TX",
  "782": "San Antonio, TX",
  "783": "San Antonio, TX",
  "784": "Austin, TX",
  "785": "Austin, TX",
  "786": "Austin, TX",
  "787": "Austin, TX",
  "788": "Austin, TX",
  "789": "Austin, TX",
  "790": "Waco, TX",
  "791": "Waco, TX",
  "792": "El Paso, TX",
  "793": "El Paso, TX",
  "794": "El Paso, TX",
  "795": "El Paso, TX",
  "796": "El Paso, TX",
  "797": "Waco, TX",
  "798": "Waco, TX",
  "799": "Waco, TX",
  "800": "Denver, CO",
  "801": "Denver, CO",
  "802": "Denver, CO",
  "803": "Denver, CO",
  "804": "Boulder, CO",
  "805": "Fort Collins, CO",
  "806": "Fort Collins, CO",
  "807": "Boulder, CO",
  "808": "Colorado Springs, CO",
  "809": "Colorado Springs, CO",
  "810": "Colorado Springs, CO",
  "811": "Colorado Springs, CO",
  "812": "Colorado Springs, CO",
  "813": "Colorado Springs, CO",
  "814": "Colorado Springs, CO",
  "815": "Colorado Springs, CO",
  "816": "Colorado Springs, CO",
  "832": "Boise, ID",
  "833": "Boise, ID",
  "834": "Boise, ID",
  "835": "Boise, ID",
  "836": "Boise, ID",
  "837": "Boise, ID",
  "838": "Boise, ID",
  "840": "Salt Lake City, UT",
  "841": "Salt Lake City, UT",
  "843": "Provo, UT",
  "844": "Provo, UT",
  "845": "Salt Lake City, UT",
  "846": "Salt Lake City, UT",
  "847": "Salt Lake City, UT",
  "850": "Phoenix, AZ",
  "851": "Phoenix, AZ",
  "852": "Phoenix, AZ",
  "853": "Phoenix, AZ",
  "855": "Tucson, AZ",
  "856": "Tucson, AZ",
  "857": "Tucson, AZ",
  "859": "Tucson, AZ",
  "860": "Tucson, AZ",
  "863": "Tucson, AZ",
  "864": "Tucson, AZ",
  "865": "Tucson, AZ",
  "870": "Albuquerque, NM",
  "871": "Albuquerque, NM",
  "873": "Albuquerque, NM",
  "874": "Albuquerque, NM",
  "875": "Santa Fe, NM",
  "877": "Albuquerque, NM",
  "878": "Albuquerque, NM",
  "879": "Albuquerque, NM",
  "880": "Albuquerque, NM",
  "881": "Albuquerque, NM",
  "882": "Albuquerque, NM",
  "883": "Albuquerque, NM",
  "884": "Albuquerque, NM",
  "885": "Albuquerque, NM",
  "890": "Las Vegas, NV",
  "891": "Las Vegas, NV",
  "893": "Las Vegas, NV",
  "894": "Las Vegas, NV",
  "895": "Las Vegas, NV",
  "897": "Reno, NV",
  "898": "Reno, NV",
  "900": "Los Angeles, CA",
  "901": "Los Angeles, CA",
  "902": "Los Angeles, CA",
  "903": "Los Angeles, CA",
  "904": "Los Angeles, CA",
  "905": "Los Angeles, CA",
  "906": "Los Angeles, CA",
  "907": "Los Angeles, CA",
  "908": "Los Angeles, CA",
  "910": "Los Angeles, CA",
  "911": "Los Angeles, CA",
  "912": "Los Angeles, CA",
  "913": "Los Angeles, CA",
  "914": "Los Angeles, CA",
  "915": "Los Angeles, CA",
  "916": "Los Angeles, CA",
  "917": "Los Angeles, CA",
  "918": "Los Angeles, CA",
  "919": "San Diego, CA",
  "920": "San Diego, CA",
  "921": "San Diego, CA",
  "922": "Riverside, CA",
  "923": "Riverside, CA",
  "924": "Riverside, CA",
  "925": "Riverside, CA",
  "926": "Oxnard, CA",
  "927": "Oxnard, CA",
  "928": "Oxnard, CA",
  "930": "Santa Barbara, CA",
  "931": "Santa Barbara, CA",
  "932": "San Luis Obispo, CA",
  "933": "San Luis Obispo, CA",
  "934": "San Luis Obispo, CA",
  "935": "San Luis Obispo, CA",
  "936": "Fresno, CA",
  "937": "Fresno, CA",
  "938": "Fresno, CA",
  "939": "Fresno, CA",
  "940": "San Francisco, CA",
  "941": "San Francisco, CA",
  "942": "Sacramento, CA",
  "943": "San Francisco, CA",
  "944": "San Francisco, CA",
  "945": "San Francisco, CA",
  "946": "San Francisco, CA",
  "947": "San Francisco, CA",
  "948": "San Francisco, CA",
  "949": "San Jose, CA",
  "950": "San Jose, CA",
  "951": "San Jose, CA",
  "952": "Stockton, CA",
  "953": "Stockton, CA",
  "954": "Santa Rosa, CA",
  "955": "Santa Rosa, CA",
  "956": "Sacramento, CA",
  "957": "Sacramento, CA",
  "958": "Sacramento, CA",
  "959": "Sacramento, CA",
  "960": "Sacramento, CA",
  "961": "Sacramento, CA",
  "967": "Honolulu, HI",
  "968": "Honolulu, HI",
  "970": "Portland, OR",
  "971": "Portland, OR",
  "972": "Portland, OR",
  "973": "Eugene, OR",
  "974": "Eugene, OR",
  "975": "Bend, OR",
  "976": "Bend, OR",
  "977": "Eugene, OR",
  "978": "Eugene, OR",
  "979": "Eugene, OR",
  "980": "Seattle, WA",
  "981": "Seattle, WA",
  "982": "Seattle, WA",
  "983": "Seattle, WA",
  "984": "Seattle, WA",
  "985": "Seattle, WA",
  "986": "Seattle, WA",
  "988": "Spokane, WA",
  "989": "Spokane, WA",
  "990": "Spokane, WA",
  "991": "Spokane, WA",
  "992": "Spokane, WA",
  "993": "Spokane, WA",
  "994": "Spokane, WA",
  "995": "Anchorage, AK",
  "996": "Anchorage, AK",
  "997": "Anchorage, AK",
  "998": "Anchorage, AK",
  "999": "Anchorage, AK",
};

/**
 * Matches free-typed city input ("austin", "Austin TX", "Austin, Texas")
 * against the known metro list. Case-insensitive, tolerant of a missing
 * or differently-formatted state suffix -- matches on the city name
 * portion first (before any comma), falling back to a full-string
 * substring match if that fails.
 */
export function findMetroMatch(input: string): MetroColData | null {
  const trimmed = input.trim().toLowerCase();
  if (!trimmed) return null;
  const cityPart = trimmed.split(",")[0].trim();

  // Exact city-name match first (most common case)
  const exact = METRO_COL_DATA.find(m => m.city.toLowerCase().split(",")[0].trim() === cityPart);
  if (exact) return exact;

  // Fall back to substring match either direction, so "San Fran" or
  // "Greater Boston" style input still has a chance of resolving
  const partial = METRO_COL_DATA.find(
    m => m.city.toLowerCase().includes(cityPart) || m.metro.toLowerCase().includes(cityPart)
  );
  return partial ?? null;
}

/**
 * Resolves a 5-digit ZIP code to the nearest of the 127 covered metros,
 * using just the first 3 digits (the real USPS "sectional center" prefix,
 * which groups ZIPs into ~900 real geographic regions). Returns null for
 * an invalid ZIP or one in a state with no covered metro nearby.
 */
export function findMetroByZip(zip: string): MetroColData | null {
  const digits = zip.trim().slice(0, 3);
  if (!/^\d{3}$/.test(digits)) return null;
  const city = ZIP3_TO_CITY[digits];
  if (!city) return null;
  return METRO_COL_DATA.find(m => m.city === city) ?? null;
}
